import { types } from 'mobx-state-tree'

const ResourceCoAuthorModel = types.model('ResourceCoAuthorModel', {
  fullName: types.maybeNull(types.string),
})

export default ResourceCoAuthorModel
